import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import DisplayComponent from '../BaseComponents/DisplayComponent';

import Header from './Header';
import './Callout.module.css';

class Callout extends PureComponent {
  render() {
    const { title, icon, copy, classes, iconColor } = this.props;
    return (
      <div className={classes} styleName="layout-correction">
        <i
          className={`fl-${icon}`}
          style={{ marginRight: '10px' }}
          styleName={iconColor}
        />
        <Header level={5} displayAs={6}>
          {title}
        </Header>

        <div>
          <p>{copy}</p>
        </div>
      </div>
    );
  }
}

Callout.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
  copy: PropTypes.string,
  classes: PropTypes.any
};

export default DisplayComponent(Callout);
